
import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from 'utils/ProtectedRoute';
import RootRedirect from 'utils/RootRedirect';

// Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));


// Store pages
import StoreList from 'pages/store/StoreList';
import CreateStore from 'pages/store/CreateStore';
import StoreView from 'pages/store/StoreView';
import StoreEdit from 'pages/store/StoreEdit';

// Product pages
import ProductList from 'pages/product/ProductList';
import ProductCategoryList from 'pages/product/ProductCategoryList';
import ProductCategoryForm from 'pages/product/ProductCategoryForm';
import ProductCategoryEdit from 'pages/product/productCategoryEdit';
import ProductSubCategoryList from 'pages/product/ProductSubCategoryList';
import ProductSubCategoryForm from 'pages/product/ProductSubCategoryForm';

// Driver pages
import DriverList from 'pages/driver/DriverList';
import DriverForm from 'pages/driver/DriverForm';
import DriverView from 'pages/driver/DriverView';

// Customer pages
import CustomerList from "pages/customer/CustomerList";
import CustomerForm from "pages/customer/CustomerForm";

// Order pages
import OrderList from 'pages/order/OrderList';

//banner
import BannerList from 'pages/banner/BannerList';
import BannerForm from 'pages/banner/BannerForm';

//offer
import OfferList from "pages/offer/OfferList";
import OfferForm from "pages/offer/OfferForm";

//user
import UserList from 'pages/user/UserList';
import RoleList from 'pages/role/RoleList';
import DayOpenList from 'pages/dayOpen/DayOpenList';

//master
import MasterProductList from 'pages/master/ProductFilteredByStoreList';
import MasterCategoryList from 'pages/master/CategoryFilteredByStoreList';

//payment
import PaymentMethodList from 'pages/payment/PaymentMethodList';

//notification
import PushNotifications from 'pages/notification/PushNotifications';
import NotificationHistory from 'pages/notification/NotificationHistory';

// Reports
import RevenueReport from 'pages/reports/RevenueReport';
import OrderReport from 'pages/reports/OrderReport';
import TaxReport from 'pages/reports/TaxReport';

// ==============================|| MAIN ROUTING ||============================== //
const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      path: '',
      element: <RootRedirect />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },

    { path: 'order/list', element: <OrderList /> },

    // ── Store ──
    {
      path: 'store',
      children: [
        { path: 'list', element: <StoreList /> },
        { path: 'create', element: <CreateStore /> },
        { path: 'view/:id', element: <StoreView /> },
        { path: 'edit/:id', element: <StoreEdit /> }
      ]
    },

    // ── Product ──
    {
      path: 'product',
      children: [
        { path: 'list', element: <ProductList /> },

        { path: 'category/list', element: <ProductCategoryList /> },
        { path: 'category/create', element: <ProductCategoryForm /> },
        { path: 'category/edit/:id', element: <ProductCategoryEdit /> },

        { path: 'sub-category/list', element: <ProductSubCategoryList /> },
        { path: 'sub-category/create', element: <ProductSubCategoryForm /> },
        { path: 'sub-category/edit/:id', element: <ProductSubCategoryForm /> }
      ]
    },
    //Driver 
    {
      path: 'driver',
      children: [
        { path: 'list', element: <DriverList /> },
        { path: 'create', element: <DriverForm /> },
        { path: 'view/:id', element: <DriverView /> },
        { path: "edit/:id", element: <DriverForm /> },
      ]
    },
    //Customer
    {
      path: 'customer',
      children: [
        { path: "list", element: <CustomerList /> },
        { path: "create", element: <CustomerForm /> },
        { path: "view/:id", element: <CustomerForm /> }
      ]
    },
    //Banner
    {
      path: "banner", children: [
        { path: "list", element: <BannerList /> },
        { path: "create", element: <BannerForm /> },
        { path: "edit/:id", element: <BannerForm /> },

      ]
    },

    //Offer
    {
      path: 'offer',
      children: [
        { path: 'list', element: <OfferList /> },
        { path: 'create', element: <OfferForm /> },
      ]
    },
    { path: 'user/list', element: <UserList /> },
    { path: 'role/list', element: <RoleList /> },
    { path: 'day/open/list', element: <DayOpenList /> },

    // ── Payment ──
    {
      path: 'payment',
      children: [
        { path: 'method/list', element: <PaymentMethodList /> }
      ]
    },

    // ── Master ──
    {
      path: 'master',
      children: [
        { path: 'product-list', element: <MasterProductList /> },
        { path: 'category-list', element: <MasterCategoryList /> }
      ]
    },
    //notification
    {
      path: 'notification',
      children: [
      { path: 'send', element: <PushNotifications /> },
      { path: 'history', element: <NotificationHistory /> }
      ]
    },

    // ── Reports ──
    {
      path: 'report',
      children: [
        { path: 'revenue', element: <RevenueReport /> },
        { path: 'order', element: <OrderReport /> },
        { path: 'tax', element: <TaxReport /> }
      ]
    }

  ]
};

export default MainRoutes;
